// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Generic Premium Page Base */
.generic-premium-page {
  font-family: 'Inter', 'Outfit', sans-serif;
  background-color: #030712;
  color: #f8fafc;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  z-index: 1;
  padding: 100px 0 80px 0;
}

/* Premium Ambient Glowing Lights */
.generic-premium-page::before {
  content: "";
  position: absolute;
  top: -20%;
  left: -10%;
  width: 50%;
  height: 50%;
  background: radial-gradient(circle, rgba(99, 102, 241, 0.15) 0%, rgba(99, 102, 241, 0) 70%);
  filter: blur(100px);
  z-index: -1;
  pointer-events: none;
}

.generic-premium-page::after {
  content: "";
  position: absolute;
  bottom: -20%;
  right: -10%;
  width: 50%;
  height: 50%;
  background: radial-gradient(circle, rgba(209, 170, 103, 0.15) 0%, rgba(209, 170, 103, 0) 70%);
  filter: blur(100px);
  z-index: -1;
  pointer-events: none;
}

/* Header Section */
.gp-header-wrapper {
  text-align: center;
  max-width: 800px;
  margin: 0 auto 60px auto;
}

.gp-badge-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: rgba(209, 170, 103, 0.1);
  border: 1px solid rgba(209, 170, 103, 0.3);
  border-radius: 50px;
  font-size: 13px;
  font-weight: 600;
  color: #e2caa0;
  margin-bottom: 24px;
}

.gp-title {
  font-size: 3.5rem;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -1px;
  color: #ffffff;
  margin-bottom: 24px;
}

.gp-text-highlight {
  color: #d1aa67 !important;
}

.gp-desc {
  font-size: 1.15rem;
  line-height: 1.6;
  color: #94a3b8;
}

/* Content Card */
.gp-content-card {
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 24px;
  padding: 60px;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.4);
}

.gp-placeholder-icon {
  width: 80px;
  height: 80px;
  border-radius: 20px;
  background: rgba(209, 170, 103, 0.1);
  color: #d1aa67;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.gp-content-title {
  font-size: 2rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 16px;
}

.gp-content-text {
  font-size: 1.1rem;
  color: #94a3b8;
  max-width: 600px;
  line-height: 1.7;
}

.gp-action-btn {
  margin-top: 32px;
  padding: 12px 32px;
  background: #d1aa67;
  color: #030712;
  font-weight: 600;
  border-radius: 50px;
  text-decoration: none;
  transition: all 0.3s ease;
  border: none;
  display: inline-block;
}

.gp-action-btn:hover {
  background: #e2caa0;
  transform: translateY(-2px);
  box-shadow: 0 10px 20px -5px rgba(209, 170, 103, 0.4);
  color: #030712;
}

/* Light Theme Overrides */
body.light_theme .generic-premium-page {
  background-color: #f8fafc;
  color: #334155;
}

body.light_theme .gp-title,
body.light_theme .gp-content-title {
  color: #0f172a;
}

body.light_theme .gp-desc,
body.light_theme .gp-content-text {
  color: #475569;
}

body.light_theme .gp-content-card {
  background: rgb(255 255 255 / 20%);
  border: 1px solid #e2e8f0;
  box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.08);
}

@media (max-width: 767px) {
  .gp-title {
    font-size: 2.5rem;
  }
  .gp-content-card {
    padding: 30px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/customComponents/GenericPremiumPage/generic-premium.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,2FAA2F;EAC3F,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,WAAW;EACX,6FAA6F;EAC7F,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,qDAAqD;EACrD,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Generic Premium Page Base */\n.generic-premium-page {\n  font-family: 'Inter', 'Outfit', sans-serif;\n  background-color: #030712;\n  color: #f8fafc;\n  min-height: 100vh;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n  padding: 100px 0 80px 0;\n}\n\n/* Premium Ambient Glowing Lights */\n.generic-premium-page::before {\n  content: \"\";\n  position: absolute;\n  top: -20%;\n  left: -10%;\n  width: 50%;\n  height: 50%;\n  background: radial-gradient(circle, rgba(99, 102, 241, 0.15) 0%, rgba(99, 102, 241, 0) 70%);\n  filter: blur(100px);\n  z-index: -1;\n  pointer-events: none;\n}\n\n.generic-premium-page::after {\n  content: \"\";\n  position: absolute;\n  bottom: -20%;\n  right: -10%;\n  width: 50%;\n  height: 50%;\n  background: radial-gradient(circle, rgba(209, 170, 103, 0.15) 0%, rgba(209, 170, 103, 0) 70%);\n  filter: blur(100px);\n  z-index: -1;\n  pointer-events: none;\n}\n\n/* Header Section */\n.gp-header-wrapper {\n  text-align: center;\n  max-width: 800px;\n  margin: 0 auto 60px auto;\n}\n\n.gp-badge-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background: rgba(209, 170, 103, 0.1);\n  border: 1px solid rgba(209, 170, 103, 0.3);\n  border-radius: 50px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #e2caa0;\n  margin-bottom: 24px;\n}\n\n.gp-title {\n  font-size: 3.5rem;\n  font-weight: 800;\n  line-height: 1.1;\n  letter-spacing: -1px;\n  color: #ffffff;\n  margin-bottom: 24px;\n}\n\n.gp-text-highlight {\n  color: #d1aa67 !important;\n}\n\n.gp-desc {\n  font-size: 1.15rem;\n  line-height: 1.6;\n  color: #94a3b8;\n}\n\n/* Content Card */\n.gp-content-card {\n  background: rgba(255, 255, 255, 0.02);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 24px;\n  padding: 60px;\n  min-height: 400px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.4);\n}\n\n.gp-placeholder-icon {\n  width: 80px;\n  height: 80px;\n  border-radius: 20px;\n  background: rgba(209, 170, 103, 0.1);\n  color: #d1aa67;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n}\n\n.gp-content-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 16px;\n}\n\n.gp-content-text {\n  font-size: 1.1rem;\n  color: #94a3b8;\n  max-width: 600px;\n  line-height: 1.7;\n}\n\n.gp-action-btn {\n  margin-top: 32px;\n  padding: 12px 32px;\n  background: #d1aa67;\n  color: #030712;\n  font-weight: 600;\n  border-radius: 50px;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  border: none;\n  display: inline-block;\n}\n\n.gp-action-btn:hover {\n  background: #e2caa0;\n  transform: translateY(-2px);\n  box-shadow: 0 10px 20px -5px rgba(209, 170, 103, 0.4);\n  color: #030712;\n}\n\n/* Light Theme Overrides */\nbody.light_theme .generic-premium-page {\n  background-color: #f8fafc;\n  color: #334155;\n}\n\nbody.light_theme .gp-title,\nbody.light_theme .gp-content-title {\n  color: #0f172a;\n}\n\nbody.light_theme .gp-desc,\nbody.light_theme .gp-content-text {\n  color: #475569;\n}\n\nbody.light_theme .gp-content-card {\n  background: rgb(255 255 255 / 20%);\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.08);\n}\n\n@media (max-width: 767px) {\n  .gp-title {\n    font-size: 2.5rem;\n  }\n  .gp-content-card {\n    padding: 30px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
